import React from "react";
import { useLanguage } from "../../utils/languageContext.js";
import { getTranslation } from "../../utils/translate.js";

/**
 * Sticky notice shown when a background check finds orders that are not in the displayed list.
 * The list itself is only reloaded when the user clicks Refresh.
 */
const NewOrdersBanner = ({ count, onRefresh }) => {
    const { language } = useLanguage();

    if (!count || count <= 0) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="sticky top-0 z-20 mb-3 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-blue-300 bg-blue-50 px-4 py-2.5 shadow-sm dark:border-[#1f6feb]/60 dark:bg-[#0d1d33]"
        >
            <div className="flex items-center gap-2 text-sm font-medium text-blue-900 dark:text-[#c9d1d9]">
                <span className="inline-flex min-w-[1.5rem] justify-center rounded-full bg-blue-600 px-2 py-0.5 text-xs font-bold tabular-nums text-white dark:bg-[#1f6feb]">
                    {count}
                </span>
                <span>{getTranslation("orderPage.newOrdersArrived", language) || "New orders arrived"}</span>
            </div>
            <button
                type="button"
                onClick={onRefresh}
                className="rounded-md bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 dark:bg-[#1f6feb] dark:hover:bg-[#388bfd]"
            >
                {getTranslation("orderPage.refreshList", language) || "Refresh"}
            </button>
        </div>
    );
};

export default NewOrdersBanner;
